import { render, staticRenderFns } from "./PatientDetailsAppointments.vue?vue&type=template&id=09809092&"
import script from "./PatientDetailsAppointments.vue?vue&type=script&lang=js&"
export * from "./PatientDetailsAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports